import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  MsalModule,
  MsalInterceptor,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { httpErrorInterceptor } from './services/interceptors/http-error.interceptor';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.msalConfig.clientId,
    authority: `https://login.microsoftonline.com/${environment.msalConfig.tenantId}`,
    redirectUri: environment.msalConfig.redirectUri,
    postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([httpErrorInterceptor])),
    importProvidersFrom(
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Redirect,
          authRequest: { scopes: environment.apiScopes },
          loginFailedRoute: '/login',
        },
        {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', environment.apiScopes],
          ]),
        }
      )
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (msal: MsalService) => async () => {
        await firstValueFrom(msal.initialize(), { defaultValue: undefined });
        await firstValueFrom(msal.handleRedirectObservable(), { defaultValue: null });
      },
      deps: [MsalService],
      multi: true,
    },
  ],
};
